import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((message, type = 'success', duration = 3000) => {
    const id = Date.now() + Math.random();
    
    const notification = {
      id,
      message,
      type,
      duration,
      createdAt: Date.now()
    };

    setNotifications(prev => [...prev, notification]);

    // ✅ RIMOSSO: Il setTimeout qui è ridondante e causa la rimozione immediata.
    // La logica di auto-rimozione è già gestita correttamente in ToastNotification.
    /*
    setTimeout(() => {
      removeNotification(id);
    }, duration);
    */

    return id;
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  const clearAll = useCallback(() => {
    setNotifications([]);
  }, []);

  return (
    <NotificationContext.Provider value={{
      notifications,
      addNotification,
      removeNotification,
      clearAll
    }}>
      {children}
    </NotificationContext.Provider>
  );
};